// src/layout/Layout.tsx
import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppFab from './components/WhatsAppFab';
import { Outlet } from 'react-router-dom';
import Container from '@mui/material/Container';

function Layout() {
  return (
    <>
      <Header />
      <Container sx={{ my: 4, minHeight:'74vh' }}>
        <Outlet />
      </Container> 
      <Footer />
      <WhatsAppFab />
    </>
  );
}

export default Layout;
